import { Box, Typography, Button } from '@mui/material';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

interface EmptyVitalsStateProps {
  onAddClick?: () => void;
}

export default function EmptyVitalsState({ onAddClick }: EmptyVitalsStateProps) {
  const { theme } = useThemeContext();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '64px 24px',
        textAlign: 'center',
        backgroundColor: theme.custom.pages.frost.authHome.cards.backgroundColor,
        borderRadius: '16px',
        border: '1px solid',
        borderColor: theme.custom.pages.frost.authHome.cards.borderColor,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '48px', mb: 2 }}>
        🩺
      </Typography>
      <Typography
        variant="h6"
        sx={{ mb: 1, fontWeight: 700, color: theme.custom.pages.frost.authHome.typography.body1.color }}
      >
        No vitals recorded yet
      </Typography>
      <Typography
        sx={{ mb: 3, color: theme.custom.pages.frost.authHome.typography.body2.color, maxWidth: '400px' }}
      >
        {onAddClick 
          ? "Add the first blood pressure and heart rate entry for this patient to start tracking their vitals."
          : "There are no vitals recorded for this patient yet."}
      </Typography>
      {onAddClick && (
        <Button variant="contained" color="primary" onClick={onAddClick}>
          Add Vitals
        </Button>
      )}
    </Box>
  );
}
